import { render, staticRenderFns } from "./BasePopupForPages.vue?vue&type=template&id=331eb82b&scoped=true"
import script from "./BasePopupForPages.vue?vue&type=script&lang=ts"
export * from "./BasePopupForPages.vue?vue&type=script&lang=ts"
import style0 from "./BasePopupForPages.vue?vue&type=style&index=0&id=331eb82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331eb82b",
  null
  
)

export default component.exports